module.exports = __webpack_public_path__ + "static/media/16UNODC6.b8aeabdb.jpg";